(function (root) {
  'use strict';
  function sizeIndex(product) {
    return product.options.findIndex((option) => /^(size|shoe size)$/i.test((typeof option === 'string' ? option : option.name).trim()));
  }
  function initialSize(product, search) {
    const params = new URLSearchParams(search);
    const index = sizeIndex(product);
    const variant = product.variants.find((item) => String(item.id) === params.get('variant'));
    return index < 0 ? '' : params.get('colour_size') || (variant ? String(variant.options[index]) : '');
  }
  function matchSize(variants, size) {
    return size ? variants.find((variant) => String(variant.size).trim() === String(size).trim()) || null : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { sizeIndex, initialSize, matchSize };
  if (!root.document) return;
  const form = document.querySelector('[data-product-form][data-enable-state="true"]');
  if (!form) return;
  const product = JSON.parse(form.dataset.product);
  const index = sizeIndex(product);
  let size = initialSize(product, location.search);
  const snapshot = () => {
    const select = form.querySelector('select[data-variants]');
    const variant = product.variants.find((item) => select && String(item.id) === select.value);
    return { form, product, index, size, variant, matched: Boolean(variant && index >= 0 && String(variant.options[index]) === size) };
  };
  const emit = () => document.dispatchEvent(new CustomEvent('leavys:size-change', { detail: snapshot() }));
  const schedule = () => setTimeout(emit, 0);
  root.LeavysProductSize = { current: snapshot, matchSize };
  form.addEventListener('change', (event) => {
    const target = event.target;
    const swatch = target.closest('.swatch');
    const selectors = Array.from(form.querySelectorAll('.single-option-selector'));
    if (index >= 0 && ((swatch && Number(swatch.dataset.optionIndex) === index) || selectors.indexOf(target) === index)) size = target.value;
    schedule();
  }, true);
  form.addEventListener('click', (event) => {
    const swatch = event.target.closest('.swatch');
    if (!swatch || Number(swatch.dataset.optionIndex) !== index) return;
    const label = event.target.closest('label');
    const radio = event.target.matches('input[type="radio"]') ? event.target : label && document.getElementById(label.htmlFor);
    if (radio) size = radio.value;
    schedule();
  }, true);
  if (typeof root.selectCallback === 'function') {
    const original = root.selectCallback;
    root.selectCallback = function (variant, selector) {
      const result = original.apply(this, arguments);
      if (selector && form.contains(selector.variantIdField)) schedule();
      return result;
    };
  }
  schedule();
})(typeof window === 'undefined' ? {} : window);
